import React from 'react';
import { BellIcon, SearchIcon, HelpCircleIcon, PlusIcon } from 'lucide-react';
import { useAuth } from '../../contexts/AuthContext';
import { Avatar } from '../ui/Avatar';
import { Badge } from '../ui/Badge';
export const TopBar: React.FC = () => {
  const {
    user,
    role,
    login
  } = useAuth();
  return <header className="h-14 bg-surface-primary border-b border-border-light flex items-center justify-between px-4 sticky top-0 z-30" data-id="element-118">
      <div className="flex items-center gap-4" data-id="element-119">
        <div className="flex items-center gap-2" data-id="element-120">
          <span className="text-fpg-navy font-bold text-lg tracking-tight" data-id="element-121">
            FairPrice Group
          </span>
          <span className="text-text-tertiary" data-id="element-122">|</span>
          <span className="text-text-secondary font-medium" data-id="element-123">
            Supplier Portal
          </span>
        </div>
        <Badge variant="warning" size="sm" className="ml-2 hidden sm:inline-flex" data-id="element-124">
          PROTOTYPE
        </Badge>
      </div>

      <div className="flex-1 max-w-xl px-8 hidden md:block" data-id="element-125">
        <div className="relative" data-id="element-126">
          <SearchIcon className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-text-tertiary" data-id="element-127" />
          <input type="text" placeholder="Search suppliers, POs, invoices... (Ctrl+K)" className="w-full bg-surface-secondary border border-transparent focus:border-fpg-navy focus:bg-surface-primary rounded-fluent pl-10 pr-4 py-1.5 text-sm transition-colors outline-none" data-id="element-128" />
        </div>
      </div>

      <div className="flex items-center gap-3" data-id="element-129">
        {/* Demo Role Switcher */}
        <select className="text-xs bg-surface-secondary border border-border-light rounded px-2 py-1 mr-2 outline-none cursor-pointer hidden lg:block" value={role || ''} onChange={e => login(e.target.value as 'supplier' | 'internal')} data-id="element-130">
          <option value="supplier" data-id="element-131">Supplier View</option>
          <option value="internal" data-id="element-132">Internal View</option>
        </select>

        <button className="p-2 text-text-secondary hover:bg-surface-secondary rounded-full transition-colors hidden sm:block" data-id="element-133">
          <PlusIcon className="w-5 h-5" data-id="element-134" />
        </button>

        <button className="p-2 text-text-secondary hover:bg-surface-secondary rounded-full transition-colors relative" data-id="element-135">
          <BellIcon className="w-5 h-5" data-id="element-136" />
          <span className="absolute top-1.5 right-1.5 w-2 h-2 bg-status-error rounded-full border-2 border-surface-primary" data-id="element-137"></span>
        </button>

        <button className="p-2 text-text-secondary hover:bg-surface-secondary rounded-full transition-colors hidden sm:block" data-id="element-138">
          <HelpCircleIcon className="w-5 h-5" data-id="element-139" />
        </button>

        <div className="ml-2 pl-4 border-l border-border-light flex items-center gap-3 cursor-pointer" data-id="element-140">
          <div className="hidden md:block text-right" data-id="element-141">
            <div className="text-sm font-medium text-text-primary" data-id="element-142">
              {user?.name}
            </div>
            <div className="text-xs text-text-tertiary" data-id="element-143">{user?.company}</div>
          </div>
          <Avatar initials={user?.name.charAt(0)} size="sm" data-id="element-144" />
        </div>
      </div>
    </header>;
};